export const PRODUCTION_PHASE_KEYS = ['A1', 'A2', 'A3', 'A1_A3'] as const
export const BUILDING_PHASE_KEYS = ['A4', 'A5'] as const
export const USE_MAINTENANCE_PHASE_KEYS = ['B1', 'B2', 'B3', 'B4', 'B5'] as const
export const DEMOLITION_PROCESSING_PHASE_KEYS = ['C1', 'C2', 'C3', 'C4'] as const
export const END_OF_LIFE_PHASE_KEYS = ['D'] as const

export const RESULT_PHASE_KEYS = [
  ...PRODUCTION_PHASE_KEYS,
  ...BUILDING_PHASE_KEYS,
  ...USE_MAINTENANCE_PHASE_KEYS,
  ...DEMOLITION_PROCESSING_PHASE_KEYS,
  ...END_OF_LIFE_PHASE_KEYS
] as const

export type ResultPhaseKey = (typeof RESULT_PHASE_KEYS)[number]

export const ACTIVITY_STAGE_KEYS = [
  'A1',
  'A2',
  'A3',
  'A1_A3',
  'A4',
  'A5',
  'B1',
  'B2',
  'B3',
  'B4',
  'B5',
  'C1',
  'C2',
  'C3',
  'C4',
  'D'
] as const

export type StageKey = (typeof ACTIVITY_STAGE_KEYS)[number]

export const RESULT_PHASE_LABELS: Record<ResultPhaseKey, string> = {
  A1: 'A1',
  A2: 'A2',
  A3: 'A3',
  A1_A3: 'A1-A3',
  A4: 'A4',
  A5: 'A5',
  B1: 'B1',
  B2: 'B2',
  B3: 'B3',
  B4: 'B4',
  B5: 'B5',
  C1: 'C1',
  C2: 'C2',
  C3: 'C3',
  C4: 'C4',
  D: 'D'
}

export const RESULT_PHASE_DEFINITIONS: readonly {
  key: ResultPhaseKey
  label: string
}[] = RESULT_PHASE_KEYS.map((key) => ({
  key,
  label: RESULT_PHASE_LABELS[key]
}))

export const LIFECYCLE_GROUP_FIELD_KEYS = [
  'production',
  'building',
  'use_maintenance',
  'demolition_processing'
] as const

export type LifecycleGroupFieldKey = (typeof LIFECYCLE_GROUP_FIELD_KEYS)[number]

const toLifecyclePhaseField = (key: ResultPhaseKey) => ({
  key,
  label: RESULT_PHASE_LABELS[key]
})

export const LIFECYCLE_COMPARISON_FIELDS: readonly {
  key: ResultPhaseKey | LifecycleGroupFieldKey
  label: string
}[] = [
  { key: 'production', label: 'Production' },
  ...PRODUCTION_PHASE_KEYS.map(toLifecyclePhaseField),
  { key: 'building', label: 'Building' },
  ...BUILDING_PHASE_KEYS.map(toLifecyclePhaseField),
  { key: 'use_maintenance', label: 'Use & Maint.' },
  ...USE_MAINTENANCE_PHASE_KEYS.map(toLifecyclePhaseField),
  { key: 'demolition_processing', label: 'Demo & Proc.' },
  ...DEMOLITION_PROCESSING_PHASE_KEYS.map(toLifecyclePhaseField),
  ...END_OF_LIFE_PHASE_KEYS.map(toLifecyclePhaseField)
]

export const isLifecycleGroupFieldKey = (fieldKey: string) => {
  return (LIFECYCLE_GROUP_FIELD_KEYS as readonly string[]).includes(fieldKey)
}

export const TRANSPORT_ACTIVITY_STAGES: readonly ResultPhaseKey[] = ['A2', 'A4', 'A5', 'C2']

export const PRODUCTION_COMBINED_STAGE = 'A1_A3'

export const PRODUCTION_INDIVIDUAL_STAGES: readonly string[] = ['A1', 'A2', 'A3']
